import React from 'react';
import { Modal } from 'react-bootstrap';
import radioOn from '../../../assets/images/matchmaker-radio-on.svg';
import radioOff from '../../../assets/images/matchmaker-radio-off.svg';

/**
 * Relationship options shared by the form and the API payload.
 * Figma: "Recommend Someone - input field open" (32:10)
 */
export const RELATIONSHIP_OPTIONS = [
  { value: 'PARENT', label: 'Parent' },
  { value: 'SIBLING', label: 'Sibling' },
  { value: 'COUSIN', label: 'Cousin' },
  { value: 'AUNT_UNCLE', label: 'Aunt / Uncle' },
  { value: 'FRIEND', label: 'Friend' },
  { value: 'COLLEAGUE', label: 'Colleague' },
  { value: 'OTHER', label: 'Other' }
];

export const getRelationshipLabel = (value) =>
  RELATIONSHIP_OPTIONS.find((opt) => opt.value === value)?.label || '';

const RelationshipSelectPopup = ({ show, value, onSelect, onClose }) => (
  <Modal
    className="matchmaker-relationship"
    backdropClassName="matchmaker-backdrop-clear"
    show={show}
    onHide={onClose}
    centered
  >
    <Modal.Body>
      <p className="mm-rel-title">Select Relationship</p>
      <div className="mm-rel-options" role="radiogroup" aria-label="Relationship">
        {RELATIONSHIP_OPTIONS.map((opt) => {
          const checked = opt.value === value;
          return (
            <button
              type="button"
              key={opt.value}
              className="mm-rel-option"
              role="radio"
              aria-checked={checked}
              onClick={() => onSelect(opt.value)}
            >
              <img src={checked ? radioOn : radioOff} alt="" />
              <span>{opt.label}</span>
            </button>
          );
        })}
      </div>
      <button type="button" className="mm-rel-close" onClick={onClose}>
        Close
      </button>
    </Modal.Body>
  </Modal>
);

export default RelationshipSelectPopup;
